import { createContext } from 'react';
import type { AnalyticsEventName, AnalyticsPayload } from '@/analytics';

export interface AnalyticsContextValue {
  track: <T extends AnalyticsEventName>(event: T, payload: AnalyticsPayload<T>) => void;
  /** False when the build ships no provider — the settings toggle stays hidden. */
  isConfigured: boolean;
  hasConsent: boolean;
  setConsent: (granted: boolean) => void;
}

export const AnalyticsContext = createContext<AnalyticsContextValue | null>(null);
